<div class="filter-wrapper" [ngClass]="{'light-background': lightBackground}" (clickOutside)="addingFilter = false">
	<div class="add-filter-button" *ngIf="!addingFilter" (click)="startAddFilter($event)">{{ 'FILTER' | translate }} +</div>

	<input type="string" class="add-filter-search" [formControl]="searchFormControl" *ngIf="addingFilter" #filterSearchEl [(ngModel)]="filterSearch">

	<ul class="add-filter" [hidden]="!addingFilter">
		<ng-container *ngIf="filterSet">
			<ng-container *ngFor="let filterGroup of filterSet">

				<li *ngFor="let filter of filterGroup.filters" (mousedown)="editFilter(filter, $event)" (mouseover)="mouseOverEditFilter(filter, $event)"
					[ngClass]="{'active': filter == activeSearchResult, 'in-filter-set': getFilterForProperty(filter.field) }"
					[hidden]="filter.hidden || !getLabelForProperty(filter.field)">
					
					<span class="num-values">{{ filter.value.length }}</span>
					<i class="fa fa-edit"></i> {{ getLabelForProperty(filter.field) }}
				</li>
			</ng-container>
		</ng-container>
		<li *ngFor="let filterConfig of addFilterSearchResults" (mousedown)="addFilter(filterConfig, $event)" (mouseover)="mouseOverAddFilter(filterConfig, $event)"
			[ngClass]="{'active': filterConfig == activeSearchResult, 'in-filter-set': getFilterForProperty(filterConfig.property)}" [hidden]="getFilterForProperty(filterConfig.property)">

			<i class="fa fa-plus"></i>{{ getLabelForProperty(filterConfig.property) }}
		</li>
	</ul>

	<div class="active-filters">
		<bb-horizontal-filterset></bb-horizontal-filterset>
	</div>
</div>
